import type { ActionTree, ActionContext } from 'vuex'
import type { Emulator } from '@/types/emulator'
import type { RootState } from '@/store'
import type { DeveloperPanelState } from './types'
import { DEVELOPER_PANEL_MUTATIONS, DEVELOPER_PANEL_ACTIONS } from './types'

interface IDeveloperPanelActions extends ActionTree<DeveloperPanelState, RootState> {
  [DEVELOPER_PANEL_ACTIONS.ADD_EMULATOR](
    context: ActionContext<DeveloperPanelState, RootState>,
    data: Emulator | Emulator[]
  ): void
  [DEVELOPER_PANEL_ACTIONS.SET_EMULATORS](
    context: ActionContext<DeveloperPanelState, RootState>,
    data: Emulator[]
  ): void
}

const actions: IDeveloperPanelActions = {
  [DEVELOPER_PANEL_ACTIONS.ADD_EMULATOR]({ commit }, data) {
    commit(DEVELOPER_PANEL_MUTATIONS.ADD_EMULATOR, data)
  },
  [DEVELOPER_PANEL_ACTIONS.SET_EMULATORS]({ commit }, data) {
    commit(DEVELOPER_PANEL_MUTATIONS.SET_EMULATORS, data)
  },
}

export default actions
